module.exports = __webpack_public_path__ + "static/ranking_bac.044100ec.jpg";